import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40ca4f20"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-700 mb-3 fs-small fw-thin text-center" }, " เพื่อสิทธิประโยชน์ของท่านเอง กรุณาป้อนข้อมูลให้ถูกต้องตามความเป็นจริง ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-warning text-center mt-8" }, " ขออภัย ปิดระบบลงทะเบียนชั่วคราว ", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "mobileNumber"
}, "เบอร์โทรศัพท์", -1))
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = {
  ref: "submitStepA1ButtonRef",
  type: "submit",
  "data-kt-element": "a_step1",
  class: "btn btn-default text-black"
}
const _hoisted_7 = { class: "indicator-label" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" กำลังดำเนินการ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "mb-10" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "otp"
}, "OTP", -1))
const _hoisted_14 = {
  class: "px-5 text-warning",
  id: "otpInfo"
}
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "mb-4 fv-row" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "ธนาคาร", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "เลือกธนาคาร", -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "mb-10 fv-row" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "เลขบัญชีธนาคาร", -1))
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "d-flex justify-content-between" }
const _hoisted_28 = {
  ref: "submitStepA2ButtonRef",
  type: "submit",
  "data-kt-element": "submitStepA2",
  class: "btn btn-default text-black w-100"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " ถัดไป ", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" กำลังดำเนินการ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = { class: "mb-4 fv-row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "เบอร์โทรศัพท์", -1))
const _hoisted_34 = { class: "mb-4 fv-row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "ธนาคาร", -1))
const _hoisted_36 = { class: "mb-4 fv-row" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "เลขที่บัญชี", -1))
const _hoisted_38 = { class: "mb-4 fv-row" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "ชื่อบัญชี", -1))
const _hoisted_40 = { class: "mb-4 fv-row" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "แนะนำโดย", -1))
const _hoisted_42 = {
  class: "mb-4fv-row",
  "data-kt-password-meter": "true"
}
const _hoisted_43 = { class: "mb-1" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " รหัสผ่าน ", -1))
const _hoisted_45 = { class: "position-relative mb-3" }
const _hoisted_46 = { class: "fv-plugins-message-container" }
const _hoisted_47 = { class: "fv-help-block" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex align-items-center mb-3",
  "data-kt-password-meter-control": "highlight"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px" })
], -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, " รหัสผ่านต้องมีความยาวไม่ต่ำกว่า 6 ตัวอักษร ", -1))
const _hoisted_50 = { class: "fv-row mb-5" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "ยืนยันรหัสผ่านอีกครั้ง", -1))
const _hoisted_52 = { class: "fv-plugins-message-container" }
const _hoisted_53 = { class: "fv-help-block" }
const _hoisted_54 = {
  key: 0,
  class: "mb-4 fv-row"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-dark fs-6" }, "รู้จักเราช่องทางไหน", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "เลือกคำตอบ", -1))
const _hoisted_57 = ["value"]
const _hoisted_58 = { class: "fv-plugins-message-container" }
const _hoisted_59 = { class: "fv-help-block" }
const _hoisted_60 = { class: "d-flex justify-content-between" }
const _hoisted_61 = {
  ref: "submitStepA3ButtonRef",
  type: "submit",
  "data-kt-element": "submitStepA3",
  class: "btn btn-default w-100"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " เสร็จสิ้น ", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" กำลังดำเนินการ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_64 = [
  _hoisted_62,
  _hoisted_63
]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "mobileNumber"
}, "เบอร์โทรศัพท์", -1))
const _hoisted_66 = { class: "input-group" }
const _hoisted_67 = {
  ref: "submitStepB1ButtonRef",
  type: "submit",
  "data-kt-element": "b_step1",
  class: "btn btn-default text-black"
}
const _hoisted_68 = { class: "indicator-label" }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" กำลังดำเนินการ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_71 = { class: "fv-plugins-message-container" }
const _hoisted_72 = { class: "fv-help-block" }
const _hoisted_73 = { class: "mb-10" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "otp"
}, "OTP", -1))
const _hoisted_75 = {
  class: "px-5 text-warning",
  id: "otpInfo"
}
const _hoisted_76 = { class: "fv-plugins-message-container" }
const _hoisted_77 = { class: "fv-help-block" }
const _hoisted_78 = { class: "d-flex justify-content-between" }
const _hoisted_79 = {
  ref: "submitStepB2ButtonRef",
  type: "submit",
  "data-kt-element": "submitStepB2",
  class: "btn btn-default text-black w-100"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " ถัดไป ", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" กำลังดำเนินการ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_82 = [
  _hoisted_80,
  _hoisted_81
]
const _hoisted_83 = { class: "mb-4 fv-row" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "เบอร์โทรศัพท์", -1))
const _hoisted_85 = { class: "mb-4 fv-row" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-dark fs-6" }, "ชื่อ", -1))
const _hoisted_87 = { class: "fv-plugins-message-container" }
const _hoisted_88 = { class: "fv-help-block" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, " ป้อนชื่อไม่ต้องมีคำนำหน้า ไม่ต้องมีช่องว่าง ", -1))
const _hoisted_90 = { class: "mb-4 fv-row" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-dark fs-6" }, "นามสกุล", -1))
const _hoisted_92 = { class: "fv-plugins-message-container" }
const _hoisted_93 = { class: "fv-help-block" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, "นามสกุลไม่ต้องมีช่องว่าง", -1))
const _hoisted_95 = { class: "mb-4 fv-row" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-dark fs-6" }, "ธนาคาร", -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "เลือกธนาคาร", -1))
const _hoisted_98 = ["value"]
const _hoisted_99 = { class: "fv-plugins-message-container" }
const _hoisted_100 = { class: "fv-help-block" }
const _hoisted_101 = { class: "mb-4 fv-row" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-dark fs-6" }, "เลขบัญชีธนาคาร", -1))
const _hoisted_103 = { class: "fv-plugins-message-container" }
const _hoisted_104 = { class: "fv-help-block" }
const _hoisted_105 = { class: "mb-4 fv-row" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "แนะนำโดย", -1))
const _hoisted_107 = {
  class: "mb-4fv-row",
  "data-kt-password-meter": "true"
}
const _hoisted_108 = { class: "mb-1" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " รหัสผ่าน ", -1))
const _hoisted_110 = { class: "position-relative mb-3" }
const _hoisted_111 = { class: "fv-plugins-message-container" }
const _hoisted_112 = { class: "fv-help-block" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex align-items-center mb-3",
  "data-kt-password-meter-control": "highlight"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px" })
], -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, " รหัสผ่านต้องมีความยาวไม่ต่ำกว่า 6 ตัวอักษร ", -1))
const _hoisted_115 = { class: "fv-row mb-5" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "ยืนยันรหัสผ่านอีกครั้ง", -1))
const _hoisted_117 = { class: "fv-plugins-message-container" }
const _hoisted_118 = { class: "fv-help-block" }
const _hoisted_119 = {
  key: 0,
  class: "mb-4 fv-row"
}
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-dark fs-6" }, "รู้จักเราช่องทางไหน", -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "เลือกคำตอบ", -1))
const _hoisted_122 = ["value"]
const _hoisted_123 = { class: "fv-plugins-message-container" }
const _hoisted_124 = { class: "fv-help-block" }
const _hoisted_125 = { class: "d-flex justify-content-between" }
const _hoisted_126 = {
  ref: "submitStepB3ButtonRef",
  type: "submit",
  "data-kt-element": "submitStepB3",
  class: "btn btn-default w-100"
}
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " เสร็จสิ้น ", -1))
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" กำลังดำเนินการ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_129 = [
  _hoisted_127,
  _hoisted_128
]
const _hoisted_130 = { class: "mb-4 fv-row" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-dark fs-6" }, "เบอร์โทรศัพท์", -1))
const _hoisted_132 = { class: "fv-plugins-message-container" }
const _hoisted_133 = { class: "fv-help-block" }
const _hoisted_134 = { class: "mb-4 fv-row" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-dark fs-6" }, "ธนาคาร", -1))
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "เลือกธนาคาร", -1))
const _hoisted_137 = ["value"]
const _hoisted_138 = { class: "fv-plugins-message-container" }
const _hoisted_139 = { class: "fv-help-block" }
const _hoisted_140 = { class: "mb-4 fv-row" }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-dark fs-6" }, "เลขบัญชีธนาคาร", -1))
const _hoisted_142 = { class: "fv-plugins-message-container" }
const _hoisted_143 = { class: "fv-help-block" }
const _hoisted_144 = { class: "mb-4 fv-row" }
const _hoisted_145 = { class: "form-label fw-bold text-dark fs-6" }
const _hoisted_146 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_147 = { class: "fv-plugins-message-container" }
const _hoisted_148 = { class: "fv-help-block" }
const _hoisted_149 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_151 = { class: "mb-4 fv-row" }
const _hoisted_152 = { class: "form-label fw-bold text-dark fs-6" }
const _hoisted_153 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_154 = { class: "fv-plugins-message-container" }
const _hoisted_155 = { class: "fv-help-block" }
const _hoisted_156 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_158 = { class: "mb-4 fv-row" }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "แนะนำโดย", -1))
const _hoisted_160 = {
  class: "mb-4fv-row",
  "data-kt-password-meter": "true"
}
const _hoisted_161 = { class: "mb-1" }
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " รหัสผ่าน ", -1))
const _hoisted_163 = { class: "position-relative mb-3" }
const _hoisted_164 = { class: "fv-plugins-message-container" }
const _hoisted_165 = { class: "fv-help-block" }
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex align-items-center mb-3",
  "data-kt-password-meter-control": "highlight"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px" })
], -1))
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, " รหัสผ่านต้องมีความยาวไม่ต่ำกว่า 6 ตัวอักษร ", -1))
const _hoisted_168 = {
  key: 0,
  class: "mb-4 fv-row"
}
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-dark fs-6" }, "รู้จักเราช่องทางไหน", -1))
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "เลือกคำตอบ", -1))
const _hoisted_171 = ["value"]
const _hoisted_172 = { class: "fv-plugins-message-container" }
const _hoisted_173 = { class: "fv-help-block" }
const _hoisted_174 = { class: "d-flex justify-content-between" }
const _hoisted_175 = {
  ref: "submitStepC1ButtonRef",
  type: "submit",
  "data-kt-element": "submitStepB3",
  class: "btn btn-default w-100"
}
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " สมัครสมาชิก ", -1))
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" กำลังดำเนินการ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_178 = [
  _hoisted_176,
  _hoisted_177
]
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_180 = [
  _hoisted_179
]
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-warning text-center" }, " กรุณาตรวจสอบความถูกต้อง ก่อนยืนยันการสมัคร ", -1))
const _hoisted_182 = { class: "mb-4 fv-row" }
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-dark fs-6" }, "เบอร์โทรศัพท์", -1))
const _hoisted_184 = { class: "mb-4 fv-row" }
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-dark fs-6" }, "ธนาคาร", -1))
const _hoisted_186 = { class: "mb-4 fv-row" }
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-dark fs-6" }, "เลขบัญชีธนาคาร", -1))
const _hoisted_188 = { class: "mb-4 fv-row" }
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-dark fs-6" }, "ชื่อ", -1))
const _hoisted_190 = { class: "mb-4 fv-row" }
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-dark fs-6" }, "นามสกุล", -1))
const _hoisted_192 = { class: "mb-4 fv-row" }
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "แนะนำโดย", -1))
const _hoisted_194 = { class: "mb-4 fv-row" }
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "รหัสผ่าน", -1))
const _hoisted_196 = {
  key: 0,
  class: "mb-4 fv-row"
}
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-dark fs-6" }, "รู้จักเราช่องทางไหน", -1))
const _hoisted_198 = { class: "d-flex justify-content-between" }
const _hoisted_199 = {
  ref: "submitStepC2ButtonRef",
  type: "submit",
  "data-kt-element": "submitStepC2",
  class: "btn btn-default w-100"
}
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " ยืนยันสมัครสมาชิก ", -1))
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" กำลังดำเนินการ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_202 = [
  _hoisted_200,
  _hoisted_201
]
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_204 = [
  _hoisted_203
]
const _hoisted_205 = { class: "vl-parent" }
const _hoisted_206 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "svg-wrapper" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    width: "80",
    height: "80",
    stroke: "#FF8040"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("g", {
        transform: "translate(1 1)",
        "stroke-width": "2"
      }, [
        /*#__PURE__*/_createElementVNode("circle", {
          "stroke-opacity": ".25",
          cx: "18",
          cy: "18",
          r: "18"
        }),
        /*#__PURE__*/_createElementVNode("path", { d: "M36 18c0-9.94-8.06-18-18-18" }, [
          /*#__PURE__*/_createElementVNode("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 18 18",
            to: "360 18 18",
            dur: "0.8s",
            repeatCount: "indefinite"
          })
        ])
      ])
    ])
  ])
], -1))
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", {
  class: "text-center",
  style: {"color":"#ff8040"}
}, [
  /*#__PURE__*/_createTextVNode(" กรุณารอสักครู่"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ระบบกำลังดำเนินการสร้างยูสเซอร์ ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_vue_countdown = _resolveComponent("vue-countdown")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.signUpCode !== 'S' && 'd-none'])
    }, _hoisted_3, 2),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.signUpCode !== 'A' && 'd-none'])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.state !== '' && _ctx.state !== 'StepA2' && 'd-none']),
        "data-kt-element": "stepA1"
      }, [
        _createVNode(_component_Form, {
          id: "formStepA1",
          class: "form",
          onSubmit: _ctx.submitStepA1,
          "validation-schema": _ctx.schemaStepA1
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Field, {
                  type: "text",
                  class: "form-control form-control-white bg-white",
                  style: {"outline":"none"},
                  placeholder: "เบอร์โทรศัพท์มือถือ",
                  name: "mobileNumber",
                  autocomplete: "off",
                  maxlength: "10",
                  ref: "mobileNumberInputRef",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state = '')),
                  onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onlyNumber($event))),
                  readonly: _ctx.counting
                }, null, 8, ["readonly"]),
                _createElementVNode("button", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, [
                    (_ctx.counting)
                      ? (_openBlock(), _createBlock(_component_vue_countdown, {
                          key: 0,
                          time: 60000,
                          onEnd: _ctx.stopCounting
                        }, {
                          default: _withCtx(({ totalSeconds }) => [
                            _createTextVNode("ขอใหม่ [" + _toDisplayString(totalSeconds) + "]", 1)
                          ]),
                          _: 1
                        }, 8, ["onEnd"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, "ขอ OTP"))
                  ]),
                  _hoisted_9
                ], 512)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_ErrorMessage, { name: "mobileNumber" })
                ])
              ])
            ]),
            _createVNode(_component_Field, {
              type: "hidden",
              name: "sponsorId",
              modelValue: _ctx.sponsorId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sponsorId) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Field, {
              type: "hidden",
              name: "seoKey",
              modelValue: _ctx.seoId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.seoId) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"]),
        _createVNode(_component_Form, {
          id: "formStepA2",
          onSubmit: _ctx.submitStepA2,
          "validation-schema": _ctx.schemaStepA2,
          class: _normalizeClass('form ' + [_ctx.state !== 'StepA2' && ' d-none'])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("span", _hoisted_14, "RefId: " + _toDisplayString(_ctx.otpRefNo) + " ภายใน 5 นาที", 1),
              _createVNode(_component_Field, {
                type: "text",
                class: "form-control form-control-white bg-white",
                placeholder: "OTP",
                name: "otp",
                autocomplete: "off",
                maxlength: "6",
                onKeypress: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onlyNumber($event)))
              }),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_ErrorMessage, { name: "otp" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_Field, {
                class: "form-select form-control-white bg-white",
                placeholder: "",
                name: "bank",
                autocomplete: "off",
                as: "select"
              }, {
                default: _withCtx(() => [
                  _hoisted_19,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banks, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: item.key,
                      key: item.key
                    }, _toDisplayString(item.value), 9, _hoisted_20))
                  }), 128))
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_ErrorMessage, { name: "bank" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createVNode(_component_Field, {
                type: "text",
                class: "form-control form-control-white bg-white",
                placeholder: "เลขบัญชีธนาคาร",
                name: "accNo",
                autocomplete: "off",
                maxlength: "12",
                onKeypress: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onlyNumber($event)))
              }),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_ErrorMessage, { name: "accNo" })
                ])
              ])
            ]),
            _createVNode(_component_Field, {
              type: "hidden",
              name: "rid",
              modelValue: _ctx.referId,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.referId) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.state = '')),
                class: "btn btn-light w-100 me-3"
              }, " ยกเลิก "),
              _createElementVNode("button", _hoisted_28, _hoisted_31, 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema", "class"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.state !== 'StepA3' && 'd-none']),
        "data-kt-element": "stepA3"
      }, [
        _createVNode(_component_Form, {
          class: "form",
          onSubmit: _ctx.submitStepA3,
          "validation-schema": _ctx.schemaStepA3
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-white",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dataTemp.mobileNumber) = $event)),
                readonly: ""
              }, null, 512), [
                [_vModelText, _ctx.dataTemp.mobileNumber]
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-white",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dataTemp.bank) = $event)),
                readonly: ""
              }, null, 512), [
                [_vModelText, _ctx.dataTemp.bank]
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-white",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dataTemp.accNo) = $event)),
                readonly: ""
              }, null, 512), [
                [_vModelText, _ctx.dataTemp.accNo]
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-white",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dataTemp.accName) = $event)),
                readonly: ""
              }, null, 512), [
                [_vModelText, _ctx.dataTemp.accName]
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dataTemp.sponsor) = $event)),
                class: "form-control form-control-white",
                readonly: ""
              }, null, 512), [
                [_vModelText, _ctx.dataTemp.sponsor]
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _createVNode(_component_Field, {
                    class: "form-control form-control-white bg-white",
                    type: "password",
                    placeholder: "",
                    name: "password",
                    autocomplete: "off"
                  }),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_ErrorMessage, { name: "password" })
                    ])
                  ])
                ]),
                _hoisted_48
              ]),
              _hoisted_49
            ]),
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createVNode(_component_Field, {
                class: "form-control form-control-white bg-white",
                type: "password",
                placeholder: "",
                name: "password_confirmation",
                autocomplete: "off"
              }),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createVNode(_component_ErrorMessage, { name: "password_confirmation" })
                ])
              ])
            ]),
            (_ctx.knowMe)
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _hoisted_55,
                  _createVNode(_component_Field, {
                    class: "form-select form-control-white bg-white",
                    placeholder: "",
                    name: "knowMe",
                    modelValue: _ctx.registerCFormData.knowMe,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.registerCFormData.knowMe) = $event)),
                    autocomplete: "off",
                    as: "select"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_56,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.knowMe, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: item,
                          key: item
                        }, _toDisplayString(item), 9, _hoisted_57))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createVNode(_component_ErrorMessage, { name: "knowMe" })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_Field, {
              type: "hidden",
              name: "rid",
              modelValue: _ctx.referId,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.referId) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Field, {
              type: "hidden",
              name: "pid",
              modelValue: _ctx.dataTemp.pid,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.dataTemp.pid) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.state = '')),
                class: "btn btn-light w-100 me-3"
              }, " ยกเลิก "),
              _createElementVNode("button", _hoisted_61, _hoisted_64, 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ], 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.signUpCode !== 'B' && 'd-none'])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.state !== '' && _ctx.state !== 'StepB2' && 'd-none']),
        "data-kt-element": "stepB1"
      }, [
        _createVNode(_component_Form, {
          id: "formStepB1",
          class: "form",
          onSubmit: _ctx.submitStepB1,
          "validation-schema": _ctx.schemaStepB1
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _hoisted_65,
              _createElementVNode("div", _hoisted_66, [
                _createVNode(_component_Field, {
                  type: "text",
                  class: "form-control form-control-white bg-white",
                  style: {"outline":"none"},
                  placeholder: "เบอร์โทรศัพท์มือถือ",
                  name: "mobileNumber",
                  autocomplete: "off",
                  maxlength: "10",
                  ref: "mobileNumberInputRef",
                  onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.state = '')),
                  onKeypress: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onlyNumber($event))),
                  readonly: _ctx.counting
                }, null, 8, ["readonly"]),
                _createElementVNode("button", _hoisted_67, [
                  _createElementVNode("span", _hoisted_68, [
                    (_ctx.counting)
                      ? (_openBlock(), _createBlock(_component_vue_countdown, {
                          key: 0,
                          time: 60000,
                          onEnd: _ctx.stopCounting
                        }, {
                          default: _withCtx(({ totalSeconds }) => [
                            _createTextVNode("ขอใหม่ [" + _toDisplayString(totalSeconds) + "]", 1)
                          ]),
                          _: 1
                        }, 8, ["onEnd"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_69, "ขอ OTP"))
                  ]),
                  _hoisted_70
                ], 512)
              ]),
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _createVNode(_component_ErrorMessage, { name: "mobileNumber" })
                ])
              ])
            ]),
            _createVNode(_component_Field, {
              type: "hidden",
              name: "sponsorId",
              modelValue: _ctx.sponsorId,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.sponsorId) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Field, {
              type: "hidden",
              name: "seoKey",
              modelValue: _ctx.seoId,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.seoId) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"]),
        _createVNode(_component_Form, {
          id: "formStepB2",
          onSubmit: _ctx.submitStepB2,
          "validation-schema": _ctx.schemaStepB2,
          class: _normalizeClass('form ' + [_ctx.state !== 'StepB2' && ' d-none'])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_73, [
              _hoisted_74,
              _createElementVNode("span", _hoisted_75, "RefId: " + _toDisplayString(_ctx.otpRefNo) + " ภายใน 5 นาที", 1),
              _createVNode(_component_Field, {
                type: "text",
                class: "form-control form-control-white bg-white",
                placeholder: "OTP",
                name: "otp",
                autocomplete: "off",
                maxlength: "6",
                onKeypress: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onlyNumber($event)))
              }),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _createVNode(_component_ErrorMessage, { name: "otp" })
                ])
              ])
            ]),
            _createVNode(_component_Field, {
              type: "hidden",
              name: "rid",
              modelValue: _ctx.referId,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.referId) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.state = '')),
                class: "btn btn-light w-100 me-3"
              }, " ยกเลิก "),
              _createElementVNode("button", _hoisted_79, _hoisted_82, 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema", "class"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.state !== 'StepB3' && 'd-none']),
        "data-kt-element": "stepB3"
      }, [
        _createVNode(_component_Form, {
          class: "form",
          onSubmit: _ctx.submitStepB3,
          "validation-schema": _ctx.schemaStepB3
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_83, [
              _hoisted_84,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-white",
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.dataTemp.mobileNumber) = $event)),
                readonly: ""
              }, null, 512), [
                [_vModelText, _ctx.dataTemp.mobileNumber]
              ])
            ]),
            _createElementVNode("div", _hoisted_85, [
              _hoisted_86,
              _createVNode(_component_Field, {
                type: "text",
                class: "form-control form-control-white bg-white",
                placeholder: "ชื่อ",
                name: "firstName",
                autocomplete: "off"
              }),
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("div", _hoisted_88, [
                  _createVNode(_component_ErrorMessage, { name: "firstName" })
                ])
              ]),
              _hoisted_89
            ]),
            _createElementVNode("div", _hoisted_90, [
              _hoisted_91,
              _createVNode(_component_Field, {
                type: "text",
                class: "form-control form-control-white bg-white",
                placeholder: "นามสกุล",
                name: "lastName",
                autocomplete: "off"
              }),
              _createElementVNode("div", _hoisted_92, [
                _createElementVNode("div", _hoisted_93, [
                  _createVNode(_component_ErrorMessage, { name: "lastName" })
                ])
              ]),
              _hoisted_94
            ]),
            _createElementVNode("div", _hoisted_95, [
              _hoisted_96,
              _createVNode(_component_Field, {
                class: "form-select form-control-white bg-white",
                placeholder: "",
                name: "bank",
                autocomplete: "off",
                as: "select"
              }, {
                default: _withCtx(() => [
                  _hoisted_97,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banks, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: item.key,
                      key: item.key
                    }, _toDisplayString(item.value), 9, _hoisted_98))
                  }), 128))
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("div", _hoisted_100, [
                  _createVNode(_component_ErrorMessage, { name: "bank" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_101, [
              _hoisted_102,
              _createVNode(_component_Field, {
                type: "text",
                class: "form-control form-control-white bg-white",
                placeholder: "เลขบัญชีธนาคาร",
                name: "accNo",
                autocomplete: "off",
                maxlength: "12",
                onKeypress: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onlyNumber($event)))
              }),
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("div", _hoisted_104, [
                  _createVNode(_component_ErrorMessage, { name: "accNo" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_105, [
              _hoisted_106,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.dataTemp.sponsor) = $event)),
                class: "form-control form-control-white",
                readonly: ""
              }, null, 512), [
                [_vModelText, _ctx.dataTemp.sponsor]
              ])
            ]),
            _createElementVNode("div", _hoisted_107, [
              _createElementVNode("div", _hoisted_108, [
                _hoisted_109,
                _createElementVNode("div", _hoisted_110, [
                  _createVNode(_component_Field, {
                    class: "form-control form-control-white bg-white",
                    type: "password",
                    placeholder: "",
                    name: "password",
                    autocomplete: "off"
                  }),
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("div", _hoisted_112, [
                      _createVNode(_component_ErrorMessage, { name: "password" })
                    ])
                  ])
                ]),
                _hoisted_113
              ]),
              _hoisted_114
            ]),
            _createElementVNode("div", _hoisted_115, [
              _hoisted_116,
              _createVNode(_component_Field, {
                class: "form-control form-control-white bg-white",
                type: "password",
                placeholder: "",
                name: "password_confirmation",
                autocomplete: "off"
              }),
              _createElementVNode("div", _hoisted_117, [
                _createElementVNode("div", _hoisted_118, [
                  _createVNode(_component_ErrorMessage, { name: "password_confirmation" })
                ])
              ])
            ]),
            (_ctx.knowMe)
              ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                  _hoisted_120,
                  _createVNode(_component_Field, {
                    class: "form-select form-control-white bg-white",
                    placeholder: "",
                    name: "knowMe",
                    modelValue: _ctx.registerCFormData.knowMe,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.registerCFormData.knowMe) = $event)),
                    autocomplete: "off",
                    as: "select"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_121,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.knowMe, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: item,
                          key: item
                        }, _toDisplayString(item), 9, _hoisted_122))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_123, [
                    _createElementVNode("div", _hoisted_124, [
                      _createVNode(_component_ErrorMessage, { name: "knowMe" })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_Field, {
              type: "hidden",
              name: "rid",
              modelValue: _ctx.referId,
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.referId) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Field, {
              type: "hidden",
              name: "pid",
              modelValue: _ctx.dataTemp.pid,
              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.dataTemp.pid) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_125, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.state = '')),
                class: "btn btn-light w-100 me-3"
              }, " ยกเลิก "),
              _createElementVNode("button", _hoisted_126, _hoisted_129, 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ], 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.signUpCode !== 'C' && 'd-none'])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.state !== '' && _ctx.state !== 'StepC1' && 'd-none']),
        "data-kt-element": "stepC1"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass({ 'overlay overlay-block': _ctx.loadingAcc })
        }, [
          _createVNode(_component_Form, {
            id: "formStepC1",
            class: "form overlay-wrapper",
            onSubmit: _ctx.submitStepC1,
            "validation-schema": _ctx.schemaStepC1
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_130, [
                _hoisted_131,
                _createVNode(_component_Field, {
                  type: "text",
                  class: "form-control form-control-white bg-white",
                  style: {"outline":"none"},
                  placeholder: "เบอร์โทรศัพท์มือถือ",
                  name: "mobileNumber",
                  modelValue: _ctx.registerCFormData.mobileNumber,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.registerCFormData.mobileNumber) = $event)),
                  autocomplete: "off",
                  maxlength: "10",
                  ref: "mobileNumberInputRef",
                  onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.validateAcc($event))),
                  onKeypress: _cache[33] || (_cache[33] = ($event: any) => (_ctx.onlyNumber($event))),
                  readonly: _ctx.counting
                }, null, 8, ["modelValue", "readonly"]),
                _createElementVNode("div", _hoisted_132, [
                  _createElementVNode("div", _hoisted_133, [
                    _createVNode(_component_ErrorMessage, { name: "mobileNumber" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_134, [
                _hoisted_135,
                _createVNode(_component_Field, {
                  class: "form-select form-control-white bg-white",
                  placeholder: "",
                  name: "bank",
                  modelValue: _ctx.registerCFormData.bank,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.registerCFormData.bank) = $event)),
                  ref: "bankInputRef",
                  autocomplete: "off",
                  onChange: _cache[35] || (_cache[35] = ($event: any) => (_ctx.validateAcc($event))),
                  as: "select"
                }, {
                  default: _withCtx(() => [
                    _hoisted_136,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banks, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.key,
                        key: item.key
                      }, _toDisplayString(item.value), 9, _hoisted_137))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_138, [
                  _createElementVNode("div", _hoisted_139, [
                    _createVNode(_component_ErrorMessage, { name: "bank" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_140, [
                _hoisted_141,
                _createVNode(_component_Field, {
                  maxlength: "12",
                  type: "text",
                  class: "form-control form-control-white bg-white",
                  placeholder: "เลขบัญชีธนาคาร",
                  name: "accNo",
                  modelValue: _ctx.registerCFormData.accNo,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.registerCFormData.accNo) = $event)),
                  autocomplete: "off",
                  onChange: _cache[37] || (_cache[37] = ($event: any) => (_ctx.validateAcc($event))),
                  onKeypress: _cache[38] || (_cache[38] = ($event: any) => (_ctx.onlyNumber($event)))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_142, [
                  _createElementVNode("div", _hoisted_143, [
                    _createVNode(_component_ErrorMessage, { name: "accNo" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_144, [
                _createElementVNode("label", _hoisted_145, [
                  _createTextVNode("ชื่อ "),
                  (!_ctx.dna)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_146, "(ตรวจสอบอัตโนมัติจากเลขบัญชี)"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_Field, {
                  type: "text",
                  class: _normalizeClass(["form-control form-control-white", { 'bg-white': _ctx.dna }]),
                  placeholder: "ชื่อ",
                  name: "firstName",
                  modelValue: _ctx.registerCFormData.firstName,
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.registerCFormData.firstName) = $event)),
                  autocomplete: "off",
                  readonly: !_ctx.dna
                }, null, 8, ["class", "modelValue", "readonly"]),
                _createElementVNode("div", _hoisted_147, [
                  _createElementVNode("div", _hoisted_148, [
                    _createVNode(_component_ErrorMessage, { name: "firstName" })
                  ])
                ]),
                (_ctx.dna)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                      _createTextVNode(" ชื่อต้องเป็นชื่อเดียวกับชื่อบัญชีธนาคาร"),
                      _hoisted_150,
                      _createTextVNode("ป้อนชื่อไม่ต้องมีคำนำหน้า ไม่ต้องมีช่องว่าง ")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_151, [
                _createElementVNode("label", _hoisted_152, [
                  _createTextVNode("นามสกุล "),
                  (!_ctx.dna)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_153, "(ตรวจสอบอัตโนมัติจากเลขบัญชี)"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_Field, {
                  type: "text",
                  class: _normalizeClass(["form-control form-control-white", { 'bg-white': _ctx.dna }]),
                  placeholder: "นามสกุล",
                  name: "lastName",
                  modelValue: _ctx.registerCFormData.lastName,
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.registerCFormData.lastName) = $event)),
                  autocomplete: "off",
                  readonly: !_ctx.dna
                }, null, 8, ["class", "modelValue", "readonly"]),
                _createElementVNode("div", _hoisted_154, [
                  _createElementVNode("div", _hoisted_155, [
                    _createVNode(_component_ErrorMessage, { name: "lastName" })
                  ])
                ]),
                (_ctx.dna)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                      _createTextVNode(" นามสกุลต้องเป็นนามสกุลเดียวกับบัญชีธนาคาร"),
                      _hoisted_157,
                      _createTextVNode("ป้อนนามสกุลไม่ต้องมีช่องว่าง ")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_158, [
                _hoisted_159,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.dataTemp.sponsor) = $event)),
                  class: "form-control form-control-white",
                  readonly: ""
                }, null, 512), [
                  [_vModelText, _ctx.dataTemp.sponsor]
                ])
              ]),
              _createElementVNode("div", _hoisted_160, [
                _createElementVNode("div", _hoisted_161, [
                  _hoisted_162,
                  _createElementVNode("div", _hoisted_163, [
                    _createVNode(_component_Field, {
                      class: "form-control form-control-white bg-white",
                      type: "password",
                      placeholder: "",
                      name: "password",
                      modelValue: _ctx.registerCFormData.password,
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.registerCFormData.password) = $event)),
                      autocomplete: "off"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_164, [
                      _createElementVNode("div", _hoisted_165, [
                        _createVNode(_component_ErrorMessage, { name: "password" })
                      ])
                    ])
                  ]),
                  _hoisted_166
                ]),
                _hoisted_167
              ]),
              (_ctx.knowMe)
                ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                    _hoisted_169,
                    _createVNode(_component_Field, {
                      class: "form-select form-control-white bg-white",
                      placeholder: "",
                      name: "knowMe",
                      modelValue: _ctx.registerCFormData.knowMe,
                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.registerCFormData.knowMe) = $event)),
                      autocomplete: "off",
                      as: "select"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_170,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.knowMe, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: item,
                            key: item
                          }, _toDisplayString(item), 9, _hoisted_171))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_172, [
                      _createElementVNode("div", _hoisted_173, [
                        _createVNode(_component_ErrorMessage, { name: "knowMe" })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_Field, {
                type: "hidden",
                name: "sponsorId",
                modelValue: _ctx.sponsorId,
                "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.sponsorId) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Field, {
                type: "hidden",
                name: "seoKey",
                modelValue: _ctx.seoId,
                "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.seoId) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Field, {
                type: "hidden",
                name: "rid",
                modelValue: _ctx.dataTemp.rid,
                "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.dataTemp.rid) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Field, {
                type: "hidden",
                name: "pid",
                modelValue: _ctx.dataTemp.pid,
                "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.dataTemp.pid) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_174, [
                _createElementVNode("button", {
                  type: "reset",
                  onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.state = '')),
                  class: "btn btn-light w-100 me-3"
                }, " ยกเลิก "),
                _createElementVNode("button", _hoisted_175, _hoisted_178, 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"]),
          _createElementVNode("div", {
            class: _normalizeClass(["overlay-layer rounded bg-dark bg-opacity-5", { 'd-none': !_ctx.loadingAcc }])
          }, _hoisted_180, 2)
        ], 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.state !== 'StepC2' && 'd-none']),
        "data-kt-element": "stepC2"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass({ 'overlay overlay-block': _ctx.loadingAcc })
        }, [
          _hoisted_181,
          _createVNode(_component_Form, {
            id: "formStepC2",
            class: "form overlay-wrapper",
            onSubmit: _ctx.submitStepC2
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_182, [
                _hoisted_183,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-white",
                  "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.registerCFormData.mobileNumber) = $event)),
                  readonly: ""
                }, null, 512), [
                  [_vModelText, _ctx.registerCFormData.mobileNumber]
                ])
              ]),
              _createElementVNode("div", _hoisted_184, [
                _hoisted_185,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-white",
                  "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.registerCFormData.bank) = $event)),
                  readonly: ""
                }, null, 512), [
                  [_vModelText, _ctx.registerCFormData.bank]
                ])
              ]),
              _createElementVNode("div", _hoisted_186, [
                _hoisted_187,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-white",
                  "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.registerCFormData.accNo) = $event)),
                  readonly: ""
                }, null, 512), [
                  [_vModelText, _ctx.registerCFormData.accNo]
                ])
              ]),
              _createElementVNode("div", _hoisted_188, [
                _hoisted_189,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-white",
                  "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.registerCFormData.firstName) = $event)),
                  readonly: ""
                }, null, 512), [
                  [_vModelText, _ctx.registerCFormData.firstName]
                ])
              ]),
              _createElementVNode("div", _hoisted_190, [
                _hoisted_191,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-white",
                  "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.registerCFormData.lastName) = $event)),
                  readonly: ""
                }, null, 512), [
                  [_vModelText, _ctx.registerCFormData.lastName]
                ])
              ]),
              _createElementVNode("div", _hoisted_192, [
                _hoisted_193,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.dataTemp.sponsor) = $event)),
                  class: "form-control form-control-white",
                  readonly: ""
                }, null, 512), [
                  [_vModelText, _ctx.dataTemp.sponsor]
                ])
              ]),
              _createElementVNode("div", _hoisted_194, [
                _hoisted_195,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.registerCFormData.password) = $event)),
                  class: "form-control form-control-white",
                  readonly: ""
                }, null, 512), [
                  [_vModelText, _ctx.registerCFormData.password]
                ])
              ]),
              (_ctx.knowMe)
                ? (_openBlock(), _createElementBlock("div", _hoisted_196, [
                    _hoisted_197,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-white",
                      "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.registerCFormData.knowMe) = $event)),
                      readonly: ""
                    }, null, 512), [
                      [_vModelText, _ctx.registerCFormData.knowMe]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_Field, {
                type: "hidden",
                name: "sponsorId",
                modelValue: _ctx.sponsorId,
                "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.sponsorId) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Field, {
                type: "hidden",
                name: "seoKey",
                modelValue: _ctx.seoId,
                "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.seoId) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Field, {
                type: "hidden",
                name: "rid",
                modelValue: _ctx.dataTemp.rid,
                "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.dataTemp.rid) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Field, {
                type: "hidden",
                name: "pid",
                modelValue: _ctx.dataTemp.pid,
                "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.dataTemp.pid) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Field, {
                type: "hidden",
                name: "mobileNumber",
                modelValue: _ctx.registerCFormData.mobileNumber,
                "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.registerCFormData.mobileNumber) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Field, {
                type: "hidden",
                name: "bank",
                modelValue: _ctx.registerCFormData.bank,
                "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.registerCFormData.bank) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Field, {
                type: "hidden",
                name: "accNo",
                modelValue: _ctx.registerCFormData.accNo,
                "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.registerCFormData.accNo) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Field, {
                type: "hidden",
                name: "firstName",
                modelValue: _ctx.registerCFormData.firstName,
                "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.registerCFormData.firstName) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Field, {
                type: "hidden",
                name: "lastName",
                modelValue: _ctx.registerCFormData.lastName,
                "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.registerCFormData.lastName) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Field, {
                type: "hidden",
                name: "password",
                modelValue: _ctx.registerCFormData.password,
                "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.registerCFormData.password) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Field, {
                type: "hidden",
                name: "knowMe",
                modelValue: _ctx.registerCFormData.knowMe,
                "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.registerCFormData.knowMe) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_198, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.state = '')),
                  class: "btn btn-light w-100 me-3"
                }, " กลับไปแก้ไข "),
                _createElementVNode("button", _hoisted_199, _hoisted_202, 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"]),
          _createElementVNode("div", {
            class: _normalizeClass(["overlay-layer rounded bg-dark bg-opacity-5", { 'd-none': !_ctx.loadingAcc }])
          }, _hoisted_204, 2)
        ], 2)
      ], 2)
    ], 2),
    _createElementVNode("div", _hoisted_205, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "onUpdate:active": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.isLoading) = $event)),
        "background-color": "#000"
      }, {
        default: _withCtx(() => [
          _hoisted_206,
          _hoisted_207
        ]),
        _: 1
      }, 8, ["active"])
    ])
  ], 64))
}